// extracted by mini-css-extract-plugin
export default {"container":"graph_container__ihHQ+","graph":"graph_graph__KTLNs","total":"graph_total__WeH7R","label":"graph_label__9VSUZ"};